import React, { Component } from 'react';
import { Link } from "react-router-dom";
import config from "./../config";

class TermIndexList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/index/';

		this.state = {
			listData: []
		};
	}

	componentDidMount() {
		if (this.props.searchParams && this.props.searchParams.ordabok) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.searchParams.ordabok && this.props.startIndex && (
			prevProps.startIndex != this.props.startIndex ||
			prevProps.searchParams.ordabok != this.props.searchParams.ordabok ||
			prevProps.searchParams.order != this.props.searchParams.order ||
			prevProps.searchParams.page != this.props.searchParams.page ||
			prevProps.term_id != this.props.term_id
		)) {
			this.fetchData();
		}
	}

	fetchData() {
		let urlParams = [
			'limit='+config.pageSize,
			'startIndex='+(this.props.startIndex || 0)
		];

		if (this.props.searchParams.ordabok) {
			urlParams.push('ordabok='+this.props.searchParams.ordabok : '');
		}
		if (this.props.searchParams.order) {
			urlParams.push('lang='+this.props.searchParams.order : 'IS');
		}
		if (this.props.searchParams.page) {
			urlParams.push('offset='+((this.props.searchParams.page-1)*config.pageSize) : '');
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results,
					prevUrl: json.previous || null,
					nextUrl: json.next || null
				})
			}.bind(this));
	}

	heimildirSelectChange(event) {
		window.location.hash = event.target.value;
	}

	render() {
		return (
			<React.Fragment>
				{
					this.state.listData.length > 0 &&
					<React.Fragment>
						<ul className="nav nav-pills flex-column">
							{
								this.state.listData.map(function(item, index) {
									return <li key={index} className={'nav-item'}><Link className={'nav-link pt-1 pb-1'+(item.fkterm == this.props.term_id ? ' active' : '')} key={index} to={'/faersla/'+item.fkterm}>{item.word}</Link></li>;
								}.bind(this))
							}
						</ul>
					</React.Fragment>
				}
			</React.Fragment>
		);
	}
}

export default TermIndexList;



// WEBPACK FOOTER //
// ./src/components/TermIndexList.js